import React, { lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

import Header from "./Components/Header/header";
import Footer from "./Components/Footer/footer";

import AIReadinessAssessment from './Components/onyxx-ai-readiness/AIReadinessAssessment';
import FloatingAssessmentWidget from './Pages/Products/Cyber/OnyxxAssis/Floatingassessmentwidget';


// CONTEXT
import { CookieConsentProvider } from "./context/CookieConsentContext";
import { CookieConsentSystem } from "./Components/CookieConsent";

import "./theme.css";

// Route-level splitting keeps unrelated page code and media out of the first load.
const Home = lazy(() => import("./Pages/Home/home"));
const Privacy = lazy(() => import("./Pages/Privacy/Policy/Policy"));
const Refund = lazy(() => import("./Pages/Privacy/ReturnPolicy/ReturnPolicy"));
const Terms = lazy(() => import("./Pages/Privacy/Terms/Terms"));
const ProductRouter = lazy(() => import("./Pages/Products/ProductRouter"));
const Onyxx = lazy(() => import("./Pages/Products/Cyber/Onyxx"));
const Product = lazy(() => import("./Pages/Products/ProductsPage"));
const Services = lazy(() => import("./Pages/Services/ApplicationServices/Appservices"));
const ApplicationDevelopment = lazy(() => import("./Pages/Services/ApplicationDevelopment/AppDev"));
const CloudInfrastructure = lazy(() => import("./Pages/Services/CloudInfrastructure/CloudInfra"));
const CyberSecurity = lazy(() => import("./Pages/Services/CyberSecurity/CyberSecurity"));
const SalesforceServices = lazy(() => import("./Pages/Services/SalesforceServices/SalesforceServices"));
const AIDataAnalytics = lazy(() => import("./Pages/Services/AIDataAnalytics/AIDataAnalytics"));
const EnterpriseSolutions = lazy(() => import("./Pages/Services/EnterpriseSolutions/EnterpriseSolutions"));
const QAManagedServices = lazy(() => import("./Pages/Services/QAManagedServices/QAManagedServices"));
const Research = lazy(() => import("./Pages/R&D/Research"));
const AiResearch = lazy(() => import("./Pages/R&D/AI/AiResearch"));
const QuantumResearch = lazy(() => import("./Pages/R&D/Quantum/QuantumResearch"));
const EdgePrivacyResearch = lazy(() => import("./Pages/R&D/Edge/EdgePrivacyResearch"));
const Network = lazy(() => import("./Pages/R&D/Network/NetworkResearch"));
const Whitepaper = lazy(() => import("./Pages/R&D/Whitepaper/Whitepaper"));
const About = lazy(() => import("./Pages/Company/About/About"));
const Careers = lazy(() => import("./Pages/Company/Careers/Careers"));
const JobDetails = lazy(() => import("./Pages/Company/Careers/JobDetails"));
const Contact = lazy(() => import("./Pages/Company/Contact/Contact"));
const Newsletter = lazy(() => import("./Pages/Company/Newsletter/Newsletter"));
const Blog = lazy(() => import("./Pages/Company/Blog/Blog"));
const BlogDetails = lazy(() => import("./Pages/Company/Blog/BlogDetails"));
const OnyxxTrail = lazy(() => import("./Pages/Products/Cyber/Onyxxdemoform"));
const ThankYou = lazy(()=>import("./Pages/Company/Contact/ThankYou"));

// Routes where the floating CTA shouldn't show — no point promoting the
// assessment to someone who's already on it.
const HIDE_WIDGET_ON = ["/ai-assesment"];

function AppShell() {
  const location = useLocation();
  const hideWidget = HIDE_WIDGET_ON.includes(location.pathname);

  return (
    <div className="app-shell">
      <Header />

      <main className="app-main">
        <Suspense fallback={<div className="route-loading" role="status" aria-live="polite"><span />Loading…</div>}>
        <Routes>
          {/* Home */}
          <Route path="/" element={<Home />} />

          {/* Product Categories */}
          <Route path="/product/:productId" element={<ProductRouter />} />
          <Route path="/product" element={<Product />} />

          {/* Services */}
          <Route path="/services" element={<Services />} />
          <Route
            path="/services/application-development"
            element={<ApplicationDevelopment />}
          />
          <Route
            path="/services/cloud-infrastructure"
            element={<CloudInfrastructure />}
          />
          <Route
            path="/services/cyber-security"
            element={<CyberSecurity />}
          />
          <Route
            path="/services/salesforce-services"
            element={<SalesforceServices />}
          />
          <Route
            path="/services/ai-data-analytics"
            element={<AIDataAnalytics />}
          />
          <Route
            path="/services/enterprise-solutions"
            element={<EnterpriseSolutions />}
          />
          <Route
            path="/services/qa-services"
            element={<QAManagedServices />}
          />
          {/* Onyxx main page */}
           <Route path="/onyxx" element={<Onyxx />} />
           
          {/* Onyxx trail form */}
          <Route
          path="/onyxxform"
          element={<OnyxxTrail/>}/>
          
          {/* AI Readiness Assessment */}
          <Route path="/ai-assesment" element={<AIReadinessAssessment />} />

          {/* R&D */}
          <Route path="/research" element={<Research />} />
          <Route path="/research/ai" element={<AiResearch />} />
          <Route path="/research/quantum" element={<QuantumResearch />} />
          <Route path="/research/edge" element={<EdgePrivacyResearch />}/>
          <Route path="/research/network" element={<Network />} />
          <Route path="/whitepaper" element={<Whitepaper />} />

          {/* Company */}
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/:jobId" element={<JobDetails />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/newslatter" element={<Newsletter />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/blogs/:slug" element={<BlogDetails />} />
          <Route path="/thank-you" element ={<ThankYou/>}/>

          {/* Privacy & Legal */}
          <Route path="/policy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund" element={<Refund />} />
         
        </Routes>
        </Suspense>
      </main>

      <Footer />

      {/* Cookie Consent - banner, modal, floating btn */}
      <CookieConsentSystem />

      {/* Floating "Free AI Readiness Check" CTA — persists across every
          route since it lives outside <Routes>, except where suppressed
          above (e.g. the assessment page itself). */}
      {!hideWidget && <FloatingAssessmentWidget />}
    </div>
  );
}

export default function App() {
  return (
    <CookieConsentProvider>
      <AppShell />
    </CookieConsentProvider>
  );
}
